import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ allowedRoles }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login/email" replace />;
  }
  if (
    isAuthenticated &&
    user?.user_type === "seller" &&
    window.location.pathname === "/"
  ) {
    return <Navigate to="/seller" replace />;
  }

  if (
    isAuthenticated &&
    user?.user_type === "admin" &&
    window.location.pathname === "/"
  ) {
    return <Navigate to="/admin" replace />;
  }

  if (
    isAuthenticated &&
    user?.user_type === "subadmin" &&
    window.location.pathname === "/"
  ) {
    return <Navigate to="/subadmin" replace />;
  }

  if (!allowedRoles.includes(user?.user_type)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;


